import Cookies from "js-cookie";
import { useContext, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { NavLink } from "react-router-dom";
import { store } from "../App";
import avatar from "../assets/images/avatar-2.jpg";

const LeftNav = () => {
  const [token, setToken, userId, setUserId] = useContext(store);
  const [first, setfirst] = useState(userId);
  const [show, setShow] = useState(true);

  const handleToggle = (event: any) => {
    // 👇️ toggle shown state
    setShow((current) => !current);

    // 👇️ or simply set it to true
    // setIsShown(true);
  };
  
  return (
    <nav
      id="sidebar"
      className="sidebar"
      style={{
        marginLeft: show ? "0px" : "-250px",
      }}
    >
      <div className="position-relative">
        <div className="position-absolute top-0 end-0 start-100 translate-bottom m-3">
          <span className="sidebar-toggle d-flex me-2" onClick={handleToggle}>
            <i className="hamburger align-self-center"></i>
          </span>
        </div>
      </div>

      <span className="sidebar-brand">AKRA</span>
      <div className="sidebar-content">
        <div className="sidebar-user">
          <img
            src={avatar}
            className="img-fluid rounded-circle mb-2"
            alt="Linda Miller"
          />
          {userId && (
            <div className="fw-bold">
              {userId.firstName} {userId.lastName}
            </div>
          )}

          {/* <small>Front-end Developer</small> */}
        </div>

        <ul className="sidebar-nav">
          <li className="sidebar-item">
            <NavLink className="sidebar-link" to={"default"}>
              <span className="align-middle">Dashboards</span>
            </NavLink>
          </li>
          <li className="sidebar-item">
            <NavLink className="sidebar-link" to={"holdings"}>
              <span className="align-middle">Holdings</span>
            </NavLink>
          </li>
          <li className="sidebar-item">
            <NavLink className="sidebar-link" to={"transactions"}>
              <span className="align-middle">Transactions</span>
            </NavLink>
          </li>
          <li className="sidebar-item">
            <NavLink className="sidebar-link" to={"balances"}>
              <span className="align-middle"> Balances</span>
            </NavLink>
          </li>
          <li className="sidebar-item">
            <NavLink className="sidebar-link" to={"performance"}>
              <span className="align-middle">Performance</span>
            </NavLink>
          </li>
          <li className="sidebar-item">
            <NavLink className="sidebar-link" to={"allocations"}>
              <span className="align-middle">Allocations</span>
            </NavLink>
          </li>
          <li className="sidebar-item">
            <NavLink className="sidebar-link" to={"trades"}>
              <span className="align-middle">Trades</span>
            </NavLink>
          </li>
          <li className="sidebar-item">
            <NavLink className="sidebar-link" to={"rebalance"}>
              <span className="align-middle">Rebalances</span>
            </NavLink>
          </li>
          <li className="sidebar-item">
            {
              Cookies.get("roles")?.includes('Admin') ?
              (<NavLink className="sidebar-link" to={"createtask"}>
            <span className="align-middle">Create Process</span>
          </NavLink>
            ): null
            }
					</li>
          <li className="sidebar-item">
            <NavLink className="sidebar-link" to={"task"}>
              <span className="align-middle">Task</span>
            </NavLink>
          </li>
          <li className="sidebar-item">
            {
              Cookies.get("roles")?.includes('Admin') ?
              (<NavLink className="sidebar-link" to={"users"}>
            <span className="align-middle">Users</span>
          </NavLink>
            ): null
            }
					</li>
          <li className="sidebar-item">
            <NavLink className="sidebar-link" to={"reports"}>
              <span className="align-middle">Reports</span>
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export { LeftNav };
